<template>
    <div class="modal fade" id="modal_add_user" tabindex="-1" data-bs-backdrop='static' aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestUser" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">

                        {{
                            modalTitle
                        }}
                    </h5>
                    <button @click="closeModal('modal_add_user', 'add')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body" v-if="requestUser">
                    <form class="forms-sample" @submit.prevent="submitForm">
                        <div class=" row">
                            <div class="row mb-3">
                                <div class="col-md-6  mb-2">
                                    <radioInput v-model="isCaputre" :valueAttr="1"
                                        :label="i18n.t('button.upload_image')" :name="`isCaputre`"
                                        :id="`isCaputre-1`" />
                                </div>
                                <div class="col-md-6  mb-2">
                                    <radioInput v-model="isCaputre" :valueAttr="0" :label="i18n.t('button.take_photo')"
                                        :name="`isCaputre`" :id="`isCaputre-0`" />
                                </div>
                            </div>
                            <div class="row  mb-4">
                                <div v-if="isCaputre" class="col-md-12 mb-3">
                                    <div class="form-group mr-b-0em">
                                        <input-image v-model="requestUser.path_image"
                                            :label="i18n.t('tables.members.name')" :pathImage="requestUser.path_image"
                                            :disabled="false" />
                                    </div>
                                </div>
                                <div v-if="!isCaputre" class="col-md-12">
                                    <capture-photo v-model="requestUser.path_image" :pathImage="requestUser.path_image"
                                        :v="v$.path_image" />
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group ">
                                    <inputText v-model="requestUser.firstName" :label="i18n.t('tables.users.firstName')"
                                        :v="v$.firstName" :disabled="false" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group ">
                                    <inputText v-model="requestUser.lastName" :label="i18n.t('tables.users.lastName')"
                                        :v="v$.lastName" :disabled="false" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group ">
                                    <inputText v-model="requestUser.email" :label="i18n.t('tables.users.email')"
                                        :v="v$.email" :disabled="false" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group ">

                                    <phone-number v-model="requestUser.phone" :label="i18n.t('tables.users.phone')"
                                        :v="v$.phone" :disabled="false" />
                                </div>
                            </div>
                            <div v-if="action == 'add'" class="col-md-6">
                                <div class="form-group ">
                                    <inputText v-model="requestUser.password" :label="i18n.t('tables.users.password')"
                                        :v="v$.password" :disabled="false" />
                                </div>
                            </div>
                            <div v-if="action == 'add'" class="col-md-6">
                                <div class="form-group ">
                                    <inputText v-model="requestUser.password_confirmation"
                                        :label="i18n.t('tables.users.password_confirmation')"
                                        :v="v$.password_confirmation" :disabled="false" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group ">
                                    <inputText v-model="requestUser.pin" :label="i18n.t('tables.users.pin')" :v="v$.pin"
                                        :disabled="false" />
                                </div>
                            </div>
                            <div v-if="action == 'add'" class="col-md-12">
                                <SingleSelect :TextLabel="i18n.t('tables.users.roles')" :trackby="`name`"
                                    :label="`name`" :valueProp="`name`" v-model="requestUser.roles"
                                    :placeholder="i18n.t('tables.users.seller')"
                                    :arrayOptions="[{ id: 1, name: 'assistance' }]" refs="sellers" :v="v$.roles" />
                            </div>






                        </div>
                        <div class="row">
                            <div class="col-md-6 text-right">

                                <button type="button" @click="closeModal('modal_add_user', 'add')"
                                    class="w-100 btn btn-cancel">
                                    {{ i18n.t('button.close') }}
                                </button>
                            </div>
                            <div class="col-md-6 text-right">
                                <button type="submit" class="w-100 btn btn-primary mr-2">
                                    {{ action == 'add' ? i18n.t('button.add') : i18n.t('button.edit') }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">

import Swal from "sweetalert2";
import i18n from "@/i18n/index"
import { defineComponent, ref, computed, watch, watchEffect, toRefs } from "vue";
/*Components*/
import inputText from "@/components/inputsValidation/ReusableInput.vue";
import SingleSelect from "@/components/inputsValidation/SingleSelect.vue";
import MultipSelect from "@/components/inputsValidation/MultipSelect.vue";
import inputTextarea from "@/components/inputsValidation/ReusableTextarea.vue";
import radioInput from "@/components/inputsValidation/radioInput.vue";


/*composables & states */
import { useModal } from '@/composables/modal/useModal';
import { useUser } from "@/composables/auth/useUser";
import { useImageConverter } from '@/composables/global/useImageConverter';
import { UserRequest } from "@/interfaces/user";
import { users, userUUID } from "@/shared/state";

import { useVuelidate } from "@vuelidate/core";
import { required, helpers, requiredIf, minLength, email, numeric, maxLength, maxValue, minValue } from "@vuelidate/validators";

export default defineComponent({
    components: {
        inputText, radioInput, SingleSelect
    },
    name: "component-inscription",
    props: {
        user: {
            type: Object,
            default: null,
        },
        modalTitle: {
            type: String,
            default: null,
        },
    },
    setup(props) {
        const APP_URL = process.env.VUE_APP_URL;
        const { user, modalTitle } = toRefs(props);
        const { closeModal } = useModal();
        const action = ref('add')
        const image = ref<any>(null)
        const isCaputre = ref<any>(0)
        const requestUser = ref<UserRequest>({
            id: null,
            firstName: null,
            lastName: null,
            email: null,
            phone: null,
            userUUID: userUUID.value,
            roles: null,
            password: null,
            password_confirmation: null,
            pin: null,
            path_image: null
        });

        watch(
            () => user.value,
            () => {

                initState(user.value)

            });

        const { addUser, editUser, isRequestUser } = useUser();
        const { selectedImage, error, handleFileChange } = useImageConverter();

        // Validation 
        const rules = {
            firstName: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
                minLength: helpers.withMessage(
                    i18n.t("validation.min.string", { value: 2, attribute: '' }),
                    minLength(2)
                )
            },
            lastName: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
                minLength: helpers.withMessage(
                    i18n.t("validation.min.string", { value: 2, attribute: '' }),
                    minLength(2)
                )
            },
            email: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
                email
            },
            phone: {
                minLength: helpers.withMessage(
                    i18n.t("validation.min.string", { value: 10, attribute: '' }),
                    minLength(10)
                ),
                maxLength: helpers.withMessage(
                    i18n.t("validation.min.string", { value: 14, attribute: '' }),
                    maxLength(14)
                )
            },
            userUUID: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
            },
            pin: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
            },

        };
        const v$ = useVuelidate(rules, requestUser, { $scope: 'user' });

        /**
         * edit or edit member
         */
        const submitForm = () => {
            v$.value.$touch();
            if (!v$.value.$invalid) {

                Swal.fire({
                    title: i18n.t("message.confirmation.edit.title"),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: i18n.t("button.edit"),
                    cancelButtonText: i18n.t("button.cancel"),
                    allowOutsideClick: false,   // ✅ disable closing by clicking outside
                    allowEscapeKey: false       // (optional) disable closing with ESC
                }).then(async (result) => {
                    if (result.isConfirmed) {

                        if (action.value == "add") {
                            addUser(requestUser.value).then((res) => {
                                if (res) {
                                    closeModal('modal_add_user', 'add')
                                }
                            })
                        } else if (action.value == "edit") {
                            editUser(requestUser.value).then((res) => {
                                if (res) {
                                    closeModal('modal_add_user', 'add')
                                }
                            })
                        }

                    }
                });
            }
        }
        const initState = (user) => {

            if (user?.id) {
                action.value = 'edit';
                requestUser.value.id = user?.id || null
                requestUser.value.firstName = user?.firstName || null
                requestUser.value.lastName = user?.lastName || null
                requestUser.value.email = user?.email || null
                requestUser.value.phone = user?.phone || null
                requestUser.value.pin = user?.pin || null
                requestUser.value.roles = user?.roles ? JSON.parse(user?.roles)[0] : null
                requestUser.value.userUUID = userUUID.value
                requestUser.value.path_image = user?.path_image ? user?.path_image : null
            } else {
                action.value = 'add';
                requestUser.value.id = null
                requestUser.value.firstName = null
                requestUser.value.lastName = null
                requestUser.value.email = null
                requestUser.value.phone = null
                requestUser.value.roles = null
                requestUser.value.pin = null
                requestUser.value.userUUID = userUUID.value
            }
            v$.value.$reset();
        };

        watch(
            () => selectedImage.value,
            (newValue) => {

                requestUser.value.path_image = selectedImage.value
            });



        return {
            /**
             * States
             */
            isCaputre,
            requestUser,
            image,
            submitForm,
            initState,
            action,
            v$,
            i18n,
            selectedImage,
            error,
            handleFileChange,
            APP_URL,
            closeModal,
            isRequestUser
        };
    },
});
</script>

<style lang="scss"></style>